'use client';

import { c as _c } from "react/compiler-runtime";
import { lookup } from '@cruz-com/lookup';
import _ from 'lodash';
import { ListBox } from '@/components';
type Props = {
  sortId: number | string;
  onSortIdChanged: (val: number) => void;
};
export function VehicleFilter2Min(t0) {
  const $ = _c(9);
  const {
    sortId,
    onSortIdChanged
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <legend className="sr-only">Sorting</legend>;
    t2 = <span className="vehicle-s2-label">Sort By:</span>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== sortId) {
    t3 = _.toNumber(sortId);
    $[2] = sortId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onSortIdChanged) {
    t4 = val => {
      onSortIdChanged(_.toNumber(val));
    };
    $[4] = onSortIdChanged;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <section aria-label="Quick Filters" className="vehicle-s2-filter"><fieldset className="flex items-center gap-x-3">{t1}{t2}<ListBox inline={true} className="min-w-[200px]" option={lookup.vehicle.sortOption} value={t3} onChange={t4} /></fieldset></section>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}